<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} habitación
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <!-- formulario -->
                <div class="form-group col-lg-2">
                  <label>N°/Código habitación <span class="required"></span></label>
                  <input type="text" class="form-control" formControlName="code_number" required [autofocus]>
                </div>
                <div class="form-group col-lg-3">
                  <label>Tipo habitación<span class="required"></span></label>
                  <select class="form-control" id="roomTypeSelected" formControlName="roomtype_id" required>
                    <option [ngValue]="null">Seleccionar opción</option>
                    <option *ngFor="let item of roomtypes" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['roomtype_id'].errors">
                    <small class="text-danger" *ngIf="f['roomtype_id'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label>N° piso</label>
                  <select class="form-control" id="roomTypeSelected" formControlName="floor">
                    <option [ngValue]="null">Seleccionar</option>
                    <option [ngValue]="1">Piso 1</option>
                    <option [ngValue]="2">Piso 2</option>
                    <option [ngValue]="3">Piso 3</option>
                    <option [ngValue]="4">Piso 4</option>
                    <option [ngValue]="5">Piso 5</option>
                    <option [ngValue]="6">Piso 6</option>
                  </select>
                  <!-- <input type="text" class="form-control" formControlName="floor" numeric> -->
                </div>
                <div class="form-group col-lg-4">
                  <label>Nombre Distintivo</label>
                  <input type="text" class="form-control" formControlName="description">
                </div>
                <div class="form-group col-lg-6">
                  <label>Observaciones</label>
                  <input type="text" class="form-control" formControlName="observations">
                </div>

                <div class="form-group col-lg-3">
                  <div class="custom-control custom-checkbox float-left m-t-25">
                    <input type="checkbox" class="custom-control-input" formControlName="is_variation_roomtype"
                      id="is_variation_roomtype" (change)="changeIsVariation()">
                    <label class="custom-control-label p-t-3" for="is_variation_roomtype">¿Variaciones de Tipo
                      Habitación?</label>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="item.value.is_variation_roomtype == true && item.value.roomtype_id != null">
              <div class="col-lg-6">
                <p class="form__group__title f-s-13"> <i class="fas fa-list-alt m-r-3"></i>Seleccione variaciones <span class="required"></span></p>
                <div class="table-responsive">
                  <table class="table mb-0 table-sm table-hover">
                    <thead class="thead-default">
                      <tr>
                        <th>Tipo Habitaciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="roomtypes.length == 0">
                        <tr>
                          <td colspan="2"><span>No se encontraron registros</span></td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="roomtypes.length > 0">
                        <tr *ngFor="let room of roomtypes; let index_ = index">
                          <ng-container *ngIf="room.id == item.value.roomtype_id">
                            <td>
                              {{room.description}} (por defecto)
                            </td>
                          </ng-container>
                          <ng-container *ngIf="room.id != item.value.roomtype_id">
                            <td>
                              <div class="custom-control custom-checkbox" style="display: inline-flex;">
                                <input class="custom-control-input" type="checkbox" value="{{room.id}}"
                                  id="bedroom_available{{room.id}}" (change)="selectedVariations(room)">
                                <label class="custom-control-label p-t-3 bold f-s-12" for="bedroom_available{{room.id}}">
                                  {{room.description}}
                                </label>
                              </div>
                            </td>
                          </ng-container>                          
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-container>

            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
